/** A web-vitals reporter, e.g. `console.log`. The installed build may not export every getter, hence the `?.` calls. */
type PerfEntryHandler = (metric: unknown) => void;
type WebVitalsModule = Partial<
  Record<"getCLS" | "getFID" | "getFCP" | "getLCP" | "getTTFB", (cb: PerfEntryHandler) => void>
>;

const reportWebVitals = (onPerfEntry?: PerfEntryHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // Asserted per read rather than annotated: the installed web-vitals build exports `onCLS`-style
    // names, so these v2 getters are absent from the module's own type — which is why every call is
    // already optional. Annotating the callback parameter is rejected contravariantly.
    import("web-vitals").then((vitals) => {
      (vitals as typeof vitals & WebVitalsModule).getCLS?.(onPerfEntry);
      (vitals as typeof vitals & WebVitalsModule).getFID?.(onPerfEntry);
      (vitals as typeof vitals & WebVitalsModule).getFCP?.(onPerfEntry);
      (vitals as typeof vitals & WebVitalsModule).getLCP?.(onPerfEntry);
      (vitals as typeof vitals & WebVitalsModule).getTTFB?.(onPerfEntry);
    });
  }
};

export default reportWebVitals;
